import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/app/hooks';
import { hasAnyPermission } from '@/services/auth';

interface PermissionProtectedRouteProps {
  permission?: string;
  permissions?: string[];
  redirectTo?: string;
}

export const PermissionProtectedRoute = ({
  permission,
  permissions,
  redirectTo = '/',
}: PermissionProtectedRouteProps) => {
  const { me } = useAppSelector((state) => state.authentication);
  const requiredPermissions = permissions ?? (permission ? [permission] : []);

  if (
    requiredPermissions.length > 0 &&
    !hasAnyPermission(me, requiredPermissions)
  ) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};
